var _path, _path2, _circle, _circle2, _circle3, _circle4, _rect, _circle5, _circle6, _rect2, _circle7, _circle8, _rect3, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 81,
    viewBox: "0 0 83 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6751 59.5812C26.1573 59.8418 26.5684 59.9923 26.9149 60.0759C26.8594 59.7175 26.8992 59.3759 27.0136 59.0653C27.0261 59.0107 27.0427 58.9567 27.0706 58.905C27.0813 58.8817 27.0924 58.8597 27.1031 58.8388C27.1043 58.8361 27.1051 58.8329 27.1063 58.8303C27.1287 58.7891 27.1554 58.7519 27.185 58.7182C27.377 58.4385 27.669 58.2331 28.0158 58.1553C28.3827 58.0736 28.7754 58.13 29.1202 58.3168C29.8185 58.695 30.12 59.497 29.8444 60.1624C29.8328 60.202 29.8168 60.2412 29.7971 60.2789C29.7959 60.281 29.7953 60.2836 29.7941 60.2859C29.7817 60.3088 29.768 60.3312 29.7482 60.3629C29.7416 60.3751 29.732 60.3832 29.7244 60.3945C29.5411 60.6839 29.2844 60.9206 28.9703 61.0926C29.1304 61.2087 29.3055 61.3107 29.4958 61.3903C29.7918 61.514 30.1287 61.5277 30.4236 61.5289C31.0571 55.4965 37.1147 50.7486 44.4744 50.7486C46.7037 50.7486 48.9056 51.1921 50.8771 52.0357C51.7088 50.9795 53.0417 50.4453 54.8482 50.4453H57.2313C57.45 50.4453 57.653 50.5598 57.766 50.7471C57.879 50.9345 57.886 51.1674 57.7841 51.3609L55.6999 55.3216C55.6781 55.3631 55.699 55.4093 55.7237 55.436C56.5086 56.3017 57.1444 57.2503 57.613 58.2548C57.895 58.8552 58.4379 59.2288 59.0302 59.2288L60.4977 59.2297C61.4542 59.2288 62.2324 60.0073 62.2324 60.9638V64.1803C62.2324 65.1368 61.4542 65.915 60.4977 65.915H59.0293C58.4368 65.915 57.8941 66.2888 57.613 66.891C56.8609 68.5061 55.6616 69.9895 54.1467 71.1813C53.7331 71.5087 53.4868 72.0368 53.4868 72.593V75.6462C53.4868 75.991 53.2073 76.2708 52.8622 76.2708H49.0782C48.7331 76.2708 48.4536 75.991 48.4536 75.6462V73.9196C45.8278 74.5668 42.9659 74.5532 40.3653 73.8868V75.6462C40.3653 75.991 40.0858 76.2707 39.7407 76.2707L35.9561 76.2713C35.611 76.2713 35.3315 75.9916 35.3315 75.6468V72.4908C35.3315 71.9432 35.0904 71.4201 34.6887 71.0942C31.9603 68.8979 30.4359 65.9513 30.3728 62.7783C29.9984 62.7751 29.5072 62.7486 29.0166 62.5447C28.4141 62.2932 27.8942 61.8926 27.5174 61.4095C26.7712 61.3883 25.9404 61.1452 25.0821 60.6807C24.7785 60.5166 24.6655 60.1378 24.8297 59.8339C24.9935 59.5301 25.3726 59.4159 25.6758 59.5812L25.6751 59.5812ZM28.5253 59.4161C28.4468 59.3732 28.3609 59.3583 28.2891 59.3749C28.2653 59.3804 28.2232 59.3938 28.2034 59.4315C28.2031 59.4324 28.2026 59.4336 28.2023 59.4344C28.1195 59.5948 28.1189 59.8251 28.1965 60.0738C28.4254 59.9933 28.6011 59.8652 28.6958 59.6904C28.6961 59.6901 28.6967 59.6895 28.6967 59.6892C28.7222 59.6389 28.6775 59.4986 28.5253 59.4161Z",
    fill: "#31B047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2021 68.18L49.1254 57.4722",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5639,
    cy: 66.3955,
    r: 1.28464,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7641,
    cy: 59.2568,
    r: 1.28464,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6636,
    cy: 49.2739,
    r: 5.85595,
    fill: "#FFD44B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.664,
    cy: 49.2739,
    r: 4.55463,
    fill: "url(#paint0_linear_1309_11607)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.7764,
    y: 49.2739,
    width: 2.66771,
    height: 2.66771,
    transform: "rotate(-45 42.7764 49.2739)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4663,
    cy: 44.5893,
    r: 5.85595,
    fill: "#FFD44B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4667,
    cy: 44.5893,
    r: 4.55463,
    fill: "url(#paint1_linear_1309_11607)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5791,
    y: 44.5894,
    width: 2.66771,
    height: 2.66771,
    transform: "rotate(-45 34.5791 44.5894)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1782,
    cy: 36.3911,
    r: 5.85595,
    fill: "#FFD44B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1787,
    cy: 36.3911,
    r: 4.55463,
    fill: "url(#paint2_linear_1309_11607)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.291,
    y: 36.3911,
    width: 2.66771,
    height: 2.66771,
    transform: "rotate(-45 46.291 36.3911)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6643,
    cy: 55.7158,
    rx: 4.68476,
    ry: 1.75678,
    fill: "#31B047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8845 26.8344C23.0183 26.0169 22.464 25.2456 21.6464 25.1118L8.32368 22.9314C7.50613 22.7976 6.73491 23.3519 6.60111 24.1695C6.4673 24.987 7.02159 25.7582 7.83914 25.892L19.6816 27.8302L17.7434 39.6726C17.6096 40.4902 18.1639 41.2614 18.9815 41.3952C19.799 41.529 20.5702 40.9747 20.704 40.1572L22.8845 26.8344ZM21.6503 56.9789C16.3026 53.7573 13.3195 50.6843 11.8571 47.9031C10.4235 45.1765 10.3931 42.6233 11.1831 40.2246C11.991 37.7713 13.678 35.4306 15.7547 33.2904C17.8221 31.1597 20.1986 29.3058 22.2796 27.8102L20.5287 25.3741C18.3869 26.9135 15.8478 28.8864 13.6016 31.2012C11.3647 33.5065 9.34017 36.2299 8.33362 39.2861C7.3091 42.3969 7.36116 45.7987 9.20184 49.2993C11.0138 52.7454 14.4969 56.1718 20.1023 59.5486L21.6503 56.9789Z",
    fill: "#31B047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9149 42.9804C62.6854 43.7765 63.1447 44.6078 63.9407 44.8372L76.9126 48.5762C77.7087 48.8056 78.54 48.3463 78.7694 47.5503C78.9988 46.7543 78.5395 45.923 77.7435 45.6935L66.2129 42.37L69.5365 30.8394C69.7659 30.0434 69.3066 29.2121 68.5106 28.9827C67.7146 28.7532 66.8833 29.2125 66.6538 30.0085L62.9149 42.9804ZM63.7512 15.1094C70.6482 18.072 74.5097 20.9319 76.4089 23.5029C78.2229 25.9586 78.2819 28.186 77.3954 30.3027C76.4556 32.5465 74.404 34.7552 71.7973 36.8168C69.2172 38.8574 66.2381 40.6424 63.6308 42.083L65.0816 44.7088C67.7413 43.2393 70.8871 41.3615 73.6583 39.1699C76.403 36.9992 78.9293 34.406 80.1625 31.4616C81.4489 28.3901 81.2761 25.0428 78.8219 21.7204C76.453 18.5134 72.0102 15.392 64.9352 12.353L63.7512 15.1094Z",
    fill: "#31B047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8065 23.557C51.1873 21.3084 53.7263 15.1236 51.4777 9.74283C49.2291 4.3621 43.0443 1.823 37.6636 4.0716C32.2829 6.32021 29.7438 12.505 31.9924 17.8858C34.241 23.2665 40.4258 25.8056 45.8065 23.557Z",
    fill: "#252525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1598 17.7827C45.1491 17.7827 45.9512 16.9807 45.9512 15.9913C45.9512 15.0019 45.1491 14.1999 44.1598 14.1999C43.1704 14.1999 42.3683 15.0019 42.3683 15.9913C42.3683 16.9807 43.1704 17.7827 44.1598 17.7827ZM46.5461 15.9913C46.5461 17.3093 45.4777 18.3777 44.1598 18.3777C42.8418 18.3777 41.7734 17.3093 41.7734 15.9913C41.7734 14.6734 42.8418 13.605 44.1598 13.605C45.4777 13.605 46.5461 14.6734 46.5461 15.9913Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6898 17.2253C42.8087 17.3713 42.7868 17.586 42.6408 17.7049C41.4016 18.7143 40.1111 19.4187 38.9703 19.7264C37.8456 20.0298 36.7715 19.968 36.0917 19.2882C35.3371 18.5336 35.3418 17.2954 35.7715 16.0216C35.8317 15.8432 36.0251 15.7473 36.2035 15.8075C36.3819 15.8677 36.4777 16.0611 36.4176 16.2395C36.0097 17.4486 36.1067 18.3389 36.5738 18.8061C36.9934 19.2257 37.7525 19.3488 38.7927 19.0681C39.8169 18.7919 41.0231 18.1433 42.2102 17.1763C42.3562 17.0574 42.5709 17.0793 42.6898 17.2253Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3104 10.5508C40.196 10.4013 40.2245 10.1873 40.374 10.0729C41.563 9.16341 42.7844 8.53724 43.8624 8.27729C44.9276 8.02045 45.938 8.10534 46.5874 8.75475C47.342 9.50941 47.3373 10.7476 46.9076 12.0214C46.8474 12.1998 46.654 12.2957 46.4756 12.2355C46.2972 12.1753 46.2013 11.9819 46.2615 11.8035C46.6694 10.5944 46.5724 9.70403 46.1052 9.23687C45.7047 8.83634 44.9956 8.70541 44.0223 8.9401C43.0618 9.17169 41.9256 9.74443 40.7883 10.6145C40.6388 10.7289 40.4248 10.7004 40.3104 10.5508Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4338 11.901C41.4338 13.2189 40.3654 14.2873 39.0475 14.2873C37.7295 14.2873 36.6611 13.2189 36.6611 11.901C36.6611 10.583 37.7295 9.51465 39.0475 9.51465C40.3654 9.51465 41.4338 10.583 41.4338 11.901ZM38.8088 10.7076H39.286V11.6621H40.2402V12.1393H39.286V13.094H38.8088V12.1393H37.8538V11.6621H38.8088V10.7076Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0117 16.196V15.7188H43.3072V16.196H45.0117Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66023 22.9916C5.53356 22.9916 5.41207 22.9413 5.3225 22.8517C5.23293 22.7622 5.18262 22.6407 5.18262 22.514V12.0464H6.13784V22.514C6.13784 22.6407 6.08752 22.7622 5.99795 22.8517C5.90839 22.9413 5.7869 22.9916 5.66023 22.9916Z",
    fill: "#252525"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6664 13.6583H9.10918L7.38447 11.728L5.6664 9.79102L3.94834 11.728L2.22363 13.6583H5.6664Z",
    fill: "#252525"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0762 20.0586V25.5776",
    stroke: "#31B047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0645 22.8179H64.9284",
    stroke: "#31B047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1592 73.8535V79.3792",
    stroke: "#31B047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1475 76.6128H73.0114",
    stroke: "#31B047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 47.7241V53.2432",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50.4834H6.86399",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4638 53.4661C80.5262 53.4661 81.3875 52.6048 81.3875 51.5424C81.3875 50.4799 80.5262 49.6187 79.4638 49.6187C78.4013 49.6187 77.54 50.4799 77.54 51.5424C77.54 52.6048 78.4013 53.4661 79.4638 53.4661Z",
    stroke: "#31B047",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1309_11607",
    x1: 41.5734,
    y1: 45.8579,
    x2: 47.9173,
    y2: 52.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1309_11607",
    x1: 33.3761,
    y1: 41.1733,
    x2: 39.72,
    y2: 47.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1309_11607",
    x1: 45.088,
    y1: 32.9751,
    x2: 51.432,
    y2: 39.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a0d78797.svg";
export { ForwardRef as ReactComponent };